// Single source for headline platform numbers, so marketing copy cannot drift from what is live.
import { instrumentIds, getInstrument } from "../instruments/registry.js";

export const INSTRUMENT_COUNT = instrumentIds().length;

// Questions a candidate answers for an instrument, as declared by the instrument itself.
export function itemCount(id, fallback) {
  const i = getInstrument(id);
  return i ? (i.totalQuestions ?? i.itemCount ?? i.items ?? i.questions?.length ?? fallback) : fallback;
}
